/**
 * Medya tavanları — istemci kopyası (9.2.2 · D-563).
 *
 * Metro'nun kökü `mobile/` olduğu için uygulama kodu `shared/`den okuyamıyor.
 * Ses kaydında kanıtlanmış desen burada da geçerli (D-543): sayı iki yerde
 * duruyor ama **ayrışamıyorlar** — `mediaLimits.test.ts` paylaşılan tabloyu
 * okuyup birebir karşılaştırıyor ve biri değişirse düşüyor.
 *
 * İstemcinin bu sayıyı bilmesi şart: 1 GB'ı yükleyip sonra sunucuda reddedilmek,
 * kullanıcının bağlantısını ve zamanını boşa harcamak demek. Sunucu yine de
 * kendi başına doğruluyor — bu kopya kolaylık, güvenlik sınırı değil.
 */
export const MEDIA_LIMITS = {
  image: { maxBytes: 10 * 1024 * 1024, maxDurationSeconds: null as number | null },
  video: { maxBytes: 1024 * 1024 * 1024, maxDurationSeconds: 600 },
  // 9.1.1 — ses kaydı. Tavan süreden türedi: 60 dakika (D-559) ve onun boyut
  // karşılığı. Medya türünün adı mesaj türüyle aynı (`voice`) — ayrı ad vermek
  // sözlükler arasında eşleme katmanı doğururdu.
  voice: { maxBytes: 256 * 1024 * 1024, maxDurationSeconds: 3600 },
} as const;

export type MediaKind = keyof typeof MEDIA_LIMITS;

export type MediaRejection = 'empty' | 'too_large' | 'too_long';

/**
 * Seçilen dosya gönderilebilir mi.
 *
 * Süre bilinmiyorsa (`undefined`) sınır uygulanmıyor: seçici bazı kaynaklarda
 * süre vermiyor ve bilinmeyen bir değeri "aştı" saymak, gönderilebilir bir
 * videoyu sebepsiz reddetmek olurdu. Sunucu zaten boyutu ölçüyor.
 */
export function rejectMedia(
  kind: MediaKind,
  sizeBytes: number | undefined,
  durationSeconds?: number
): MediaRejection | null {
  const limits = MEDIA_LIMITS[kind];
  // Boş dosya sunucuda zaten reddediliyor; burada da reddedilmesinin sebebi
  // hatanın ağa çıkmadan, adı konmuş biçimde görünmesi.
  if (typeof sizeBytes === 'number' && (!Number.isFinite(sizeBytes) || sizeBytes <= 0)) {
    return 'empty';
  }
  if (typeof sizeBytes === 'number' && Number.isFinite(sizeBytes) && sizeBytes > limits.maxBytes) {
    return 'too_large';
  }
  if (
    limits.maxDurationSeconds !== null
    && typeof durationSeconds === 'number'
    && Number.isFinite(durationSeconds)
    && durationSeconds > limits.maxDurationSeconds
  ) {
    return 'too_long';
  }
  return null;
}
